import styled from 'styled-components';
import { fontDisplay, fontUi } from '../../../theme/typography';

export const StyledRound = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const StyledGroup = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 44px;
  background-color: transparent;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  width: 100%;
`;

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
`;

export const StyledRoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 4px 10px;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
`;
export const StyledTitle = styled.h4`
  ${fontDisplay};
  margin: 0;
  font-size: 15px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.text};
`;
export const StyledDate = styled.span`
  ${fontUi};
  font-size: 11px;
  font-weight: 600;
  color: ${({ theme }) => theme.textFaint};
`;
